import { atomFamily, selector } from 'recoil';
import { CompanyModel, CompanyType } from 'models/CompanyModel';
import Api from 'utils/api';


const companyList = atomFamily<CompanyModel[], CompanyType>({
    key: 'companyList',
    default: type => selector({
        key: `companyList/${type}/default`,
        get: async () => {
            try {
                return (await Api.company.all(type)).data;
            } catch (e) {
                return [];
            }
        }
    }),
});

export default companyList;
